module.exports = __webpack_public_path__ + "static/media/comic-move-02.e5610aa5.png";